module.exports = __webpack_public_path__ + "static/media/apple-pay-wordmark.dc944dcb.svg";